import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../../features/auth/authSlice";

const ProtectedRoute = () => {
  const user = useUser()
  return user?.token ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
